import { WorkingHour } from '../types/api';

/**
 * Круглосуточный день в каноничном виде (ADR-027): с полуночи до полуночи
 * следующего дня, без перерыва.
 *
 * Отдельной колонки на бэке нет — смысл несут сами времена, поэтому такой
 * день понимают и выпущенные сборки мобилки, и фильтр «открыто сейчас».
 * Кабинет шлёт эти поля вместе с `is_round_the_clock: true`: новый сервер
 * приводит день к этому виду сам, старый просто сохранит времена.
 */
export const ROUND_THE_CLOCK_HOURS = {
  open_time: '00:00',
  close_time: '00:00',
  is_day_off: false,
  closes_next_day: true,
  break_start: null,
  break_end: null,
} as const;

type RoundTheClockSource = Pick<WorkingHour, 'is_day_off' | 'open_time' | 'close_time' | 'is_round_the_clock'>;

/**
 * Работает ли заведение в этот день круглосуточно.
 *
 * Новый сервер присылает `is_round_the_clock` — ему и верим. У старого поля
 * нет, и сутки узнаём по временам тем же правилом, что бэк
 * (WorkingHour::meansRoundTheClock): «открытие = закрытие» — так
 * круглосуточный день понимает мобилка — или 00:00–23:59 из сидеров.
 * Время сравнивается по первым пяти символам: «23:59:00» — тоже 23:59.
 */
export function isRoundTheClock(wh: RoundTheClockSource): boolean {
  if (wh.is_day_off) return false;
  if (typeof wh.is_round_the_clock === 'boolean') return wh.is_round_the_clock;

  const open = wh.open_time?.slice(0, 5);
  const close = wh.close_time?.slice(0, 5);
  if (!open || !close) return false;
  return open === close || (open === '00:00' && close === '23:59');
}
